import { useQuery } from '@tanstack/react-query';
import {
  shouldReactQueryKeepPreviousData,
} from '../task.constants';
import { fetchAccessibleForms } from '../../api/fetchSystemApps';
import { useApp } from '../../hooks/use-app';

const useOrgApps = () => {
  const app = useApp();
  const queryOptions = {
    keepPreviousData: shouldReactQueryKeepPreviousData,
  };
  const { data: orgApps } = useQuery(
    ['orgApps'],
    () => fetchAccessibleForms(app.api.token), queryOptions,
  );

  return orgApps?.forms || [];
};

export default useOrgApps;
